export default __webpack_public_path__ + "static/media/GR00035-mentor_amulet_4.eb11edec.svg";